import { ListSubheader, MenuItem, TextField } from "@mui/material";
import { Popover } from "../Popover";
import { useEffect, useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SelectEditor(props) {
    const [search, setSearch] = useState("");
    const [showInitial, setShowInitial] = useState(true);
    const opts = props.options.filter(opt => { if (search === "")
        return true; if (opt.subHeading)
        return true; return opt.display.toLowerCase().indexOf(search.toLowerCase()) === 0; });
    const valueIndex = opts.findIndex(o => o.value === props.value);
    const [keyIndex, setKeyIndex] = useState(valueIndex);
    const hasFreeSolo = !!props.freeSolo && !!search;
    const onSearch = props.onSearch;
    useEffect(() => { if (!onSearch)
        return; onSearch(search); }, [onSearch, search]);
    return /*#__PURE__*/ _jsx(Popover, { anchorEl: props.anchor, open: true, style: { fontSize: "0.5rem" }, PaperProps: { style: { minWidth: props.anchor.getBoundingClientRect().width } }, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: props.onBlur, children: /*#__PURE__*/ _jsxs("form", { onSubmit: e => { e.preventDefault(); const val = opts[keyIndex]; if (val) {
                props.onSelect(val.value);
                return;
            } }, children: [/*#__PURE__*/ _jsx(TextField, { fullWidth: true, autoComplete: "off", autoFocus: true, onKeyDown: e => {
                        if (e.key === "ArrowUp") {
                            if (keyIndex < 0) {
                                return; // do nothing
                            }
                            setKeyIndex(keyIndex - 1);
                            return;
                        }
                        else if (e.key === "ArrowDown") {
                            setKeyIndex(keyIndex + 1);
                        }
                    }, onChange: e => { const val = e.target.value; setSearch(val); setShowInitial(false); if (val !== "") {
                        setKeyIndex(0);
                    }
                    else {
                        setKeyIndex(valueIndex);
                    } }, value: showInitial ? props.initialValue || "" : search }), opts.map((o, index) => { if (o.subHeading) {
                    return /*#__PURE__*/ _jsx(ListSubheader, { children: o.display }, "sub-" + index);
                } return /*#__PURE__*/ _jsx(MenuItem, { onClick: () => props.onSelect(o.value), selected: keyIndex === index, value: o.value, style: { fontSize: "0.8rem" }, children: o.display }, o.value); }), hasFreeSolo && /*#__PURE__*/ _jsx(MenuItem, { onClick: () => props.onSelect(search, true), value: search, selected: keyIndex === opts.length, style: { fontSize: "0.8rem" }, children: search }, "free-solo"), search && opts.length === 0 && !hasFreeSolo && /*#__PURE__*/ _jsx("div", { style: { padding: 8, fontSize: "0.8rem", textAlign: "center" }, children: "No matches" })] }) });
}
